/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

import { IconContext } from 'react-icons';
import { GrLocation, GrFormDown } from 'react-icons/gr';
import { ImArrowLeft2 } from 'react-icons/im';
import { BsPlus } from 'react-icons/bs';
import { doTopUp } from '../../actions/topUpAction';

import { formatCurrency } from '../../utils/Helpers';
import ModalSellerLocationV3 from '../Modals/ModalSellerLocationV3';
import ModalSellerPoint from '../Modals/ModalSellerPoint';
import { ModalPenaltyAlert } from '../Modals';
import TopupForm from './Modals/TopupForm';

import Current from './SellingTabs/Current';
import InProgress from './SellingTabs/InProgress';
import History from './SellingTabs/History';
import PenjualanLoadingSkeleton from './PenjualanLoadingSkeleton';
import SuspendedInfo from './SuspendedInfo';
import SellerVerification from '../PageSellerRegistration/SellerVerification';
import { Select } from 'antd';
import 'antd/es/select/style/css';
import Styles from './Penjualan.module.scss';

// ========= action import section ========= //
import {
  historySelling,
  listSelling,
  processSelling,
  submitHolidayMode,
  settleWithKickCredit,
  getSellingCommissionSetting,
} from '../../actions/dashboardAction';
import {
  doFetchCurrencyRate,
  doFetchProfile,
  doHolidayMode,
  doUpdateUserProfile,
  updateUserCountry,
  doRefreshToken,
  doSentLinkVerificationEmail,
} from '../../actions/authAction';
import { doResetDashboardFilter } from '../../actions/uiAction';
import {
  doFetchCountries,
  doFetchProvinces,
} from '../../actions/postalCodeAction';
import {
  doVerifyOtp,
  doSentCitCall,
  doSentSMS,
  doSubmitPhone,
} from '../../actions/saleActions';
// ====== end of action import section ====== //

// ========= interface import section ========= //
import DataHistoryInterface, {
  PenjualanInterface,
} from '../../interface/reducers/history';
import RouteHistoryInterface from '../../interface/router';
import AuthInterface, {
  UserDataInterface,
} from '../../interface/reducers/auth';
import DataUIInterface from '../../interface/reducers/ui';
import DataPostalCodeInterface, {
  CountriesStateInterface,
  ProvinceStateInterface,
} from '../../interface/reducers/postalCode';
// ====== end of interface import section ====== //

import REVENUE_IMG from '../../images/rev1024.png';
import SALES_IMG from '../../images/sales1024.png';
import STATUS_IMG from '../../images/status1024.png';
import UNVERIFIED_IMG from '../../images/unverified.png';
import { CURRENCY_CODE } from '../../constants';
import { toast } from 'react-toastify';
import GREEN_STAR from '../../images/green-star.png';
import RED_WARNING from '../../images/warning-red.png';
import INFO_BUTTON from '../../images/info-button.png';
import HOLIDAY_ICON_RED from '../../images/holiday-icon-red.png';
import ModalBulkUpload from './ModalBulkUpload';
import { useGetViewType } from 'Pages/Home/Hooks/useGetViewType';

type queryGetData = {
  params: {
    category: string;
    keyword: string;
    page: number;
    sneakers_condition: string;
    sort_by: string;
    status: string;
  };
};

type payloadSubmitHolidayMode = {
  active: boolean;
};

type UpdateProfileType = {
  email: string;
  first_name: string;
  family_name: string;
  sex: string;
  birthed_at: string;
  seller_location_id: number | undefined;
};

type UpdateUserCountryType = {
  country_code: string | undefined;
};

type penjualanProps = {
  history: RouteHistoryInterface;

  // Map state to Props
  penjualan: PenjualanInterface;
  ratio: number;
  currency: string;
  userData: UserDataInterface;
  dataUi: DataUIInterface;
  countries: CountriesStateInterface;
  provinces: ProvinceStateInterface;
  dataAuth: any;

  // Map dispatch to Props
  doListSelling: (query: queryGetData, ascDesc?: any) => Promise<any>;
  doListSellingProcess: (query: queryGetData, ascDesc?: any) => Promise<any>;
  doSellsHistory: (query: queryGetData, ascDesc?: any) => Promise<any>;
  toggleHolidayModeProfile: (bool: boolean) => Promise<any>;
  doSubmitHolidayMode: (payload: payloadSubmitHolidayMode) => Promise<any>;
  doResetFilter: () => Promise<any>;
  fetchProvinces: (country: string) => Promise<any>;
  fetchCountries: () => Promise<any>;
  fetchProfile: () => Promise<any>;
  updateProfile: (payload: UpdateProfileType) => Promise<any>;
  doUpdateUserCountry: (payload: UpdateUserCountryType) => Promise<any>;
  getCountries: () => any;
  doRefreshToken: () => any;
  fetchCurrencyRate: (payload) => any;
  doVerifyEmail: () => Promise<any>;
  refreshToken: () => Promise<any>;
  settleWithKickCredit: () => Promise<any>;
};

type stateToProps = {
  dataHistory: DataHistoryInterface;
  dataAuth: AuthInterface;
  dataUi: DataUIInterface;
  dataPostalCode: DataPostalCodeInterface;
  dataTopUp: { pengisian: any; topUp: any };
};

const TABS = ['Current', 'In Progress', 'History'];

/**
 * Selling User Dashboard section for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {penjualanProps} props for this component.
 * @return {JSX.Element}
 */
function Penjualan({
  history,
  doListSelling,
  doListSellingProcess,
  doSellsHistory,
  dataUi,
  penjualan,
  ratio,
  currency,
  userData,
  toggleHolidayModeProfile,
  doSubmitHolidayMode,
  doResetFilter,
  fetchProvinces,
  doVerifyEmail,
  countries,
  provinces,
  fetchProfile,
  updateProfile,
  doUpdateUserCountry,
  getCountries,
  fetchCurrencyRate,
  dataAuth,
  doRefreshToken,
  refreshToken,
  doSubmitPhone,
  doVerifyOtp,
  doSentCitCall,
  doSentSMS,
  topUp,
  pengisian,
  topup,
  balance,
  settleWithKickCredit,
  seller_points,
  balance_with_fee,
  getSellingCommissionSetting,
}: penjualanProps): JSX.Element {
  const isSellerCreditMinus =
    parseInt(dataAuth?.userdata?.balance_with_fee ?? '0') < 0;
  const hasSuspendedSeller =
    dataAuth?.userdata?.roles?.includes('suspended_seller');
  const sellerPointsLessThanFive = parseInt(seller_points) < 5;
  const isSuspended = hasSuspendedSeller || sellerPointsLessThanFive;
  const [firstRender, setFirstRender] = useState(true);
  const [sellingCommissionData, setSellingCommissionData] = useState([]);
  const [activeTabs, setActiveTabs] = useState(TABS[0]);
  const [isGettingData, setGettingData] = useState(false);
  const [isUnverified, setUnverified] = useState(false);
  const [urlAfterSuccessTopup, setUrlAfterSuccessTopup] = useState('');
  const [isOpenModalBulkUpload, setIsOpenModalBulkUpload] = useState(false);
  const [selectedActionBulkUpload, setSelectedActionBulkUpload] =
    useState<'add' | 'edit'>('add');
  const { isMobileView, isDesktopView } = useGetViewType();

  useEffect(() => {
    if (!userData.isFetch && userData.roles.includes('unverified_user')) {
      setUnverified(true);
      return;
    }
    if (
      !userData.isFetch &&
      userData.roles &&
      userData.roles.indexOf('user') !== -1 &&
      userData.roles.indexOf('seller') === -1
    ) {
      history.push('/seller-registration');
      return;
    }
    if (userData.country_code && userData.country_code !== 'IDN') {
      history.replace('/user_dashboard/profile-settings');
      return;
    }
  }, [userData]);

  // =========== Modal Seller Location State =========== //
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [locationSubmitted, setLocationSubmitted] = useState(false);
  const [errorLocation, setErrorLocation] = useState<any>(null);

  const [countryList, setCountryList] = useState([
    { value: '', label: 'Country*' },
  ]);
  const [provinceList, setProvinceList] = useState([
    { value: 0, label: 'Province*' },
  ]);
  const [country, setCountry] = useState(null);
  const [province, setProvince] = useState(null);
  const [countrySelected, setCountrySelected] =
    useState<{
      value: string;
      label: string;
    } | null>(null);
  const [provinceSelected, setProvinceSelected] =
    useState<{
      value: number;
      label: string;
    } | null>(null);

  //seller verification
  const [isOpenSellerVerification, setOpenSellerVerification] = useState(false);
  const [phone, setPhone] = useState('');
  const [isOpenExistingModal, setIsOpenExistingModal] = useState(false);

  //top up
  const [isOpenModalTopup, setIsOpenModalTopup] = useState(false);
  const [isOpenModalAlert, setIsOpenModalAlert] = useState(false);
  //end of top up

  function toggleSellerVerification() {
    setOpenSellerVerification(!isOpenSellerVerification);
  }
  function toggleExistingModal() {
    setIsOpenExistingModal(!isOpenExistingModal);
  }
  //end seller verification

  const toggleModalSellerLocation = () => {
    const sellerLocation =
      userData &&
      userData.user_setting &&
      userData.user_setting.seller_location_id;
    setIsOpen(!isOpen);
    setLocationSubmitted(false);
    setErrorLocation(null);
    if (!sellerLocation) history.replace('/user_dashboard/profile-settings');
  };

  const toggleModalSellerPoint = () => {
    setIsOpenModal(!isOpenModal);
  };

  const handleCountryChange = (selected: any) => {
    setCountry(!selected ? null : selected.label);
    setCountrySelected(!selected ? null : selected);
    setProvince(null);
    setProvinceSelected(null);
    setErrorLocation(null);
    if (selected) {
      fetchProvinces(selected.value);
    }
  };
  const handleProvinceChange = (selected: any) => {
    setProvince(!selected ? null : selected.label);
    setProvinceSelected(!selected ? null : selected);
    setErrorLocation(null);
  };
  const validateForm = () => {
    const errors: any = {};
    if (countrySelected == null || countrySelected === '') {
      errors['countrySelected'] = ['Please select your country location.'];
    }
    if (provinceSelected == null || provinceSelected === '') {
      errors['provinceSelected'] = ['Please select your province location.'];
    }
    if (Object.keys(errors).length) {
      setErrorLocation({
        errors,
        status_code: 422,
        message: 'Please fill the form',
      });
    }
    return errors;
  };
  const onSubmitLocation = () => {
    if (!Object.keys(validateForm()).length) {
      const payload = {
        email: userData.email,
        first_name: userData.first_name,
        family_name: userData.family_name,
        sex: userData.sex,
        birthed_at: userData.birthed_at,
        seller_location_id: provinceSelected?.value,
      };
      const data = {
        country_code: countrySelected?.value,
      };

      updateProfile(payload).then(() => {
        doUpdateUserCountry(data).then(() => {
          const currencyCode =
            CURRENCY_CODE[countrySelected?.value === 'IDN' ? 'IDN' : 'ETC'];
          fetchCurrencyRate(currencyCode);
          doFetchProfile();
          if (
            countrySelected?.value === 'MYS' ||
            countrySelected?.value === 'SGP'
          ) {
            history.push('/user_dashboard/profile-settings');
          }
        });
        setLocationSubmitted(false);
        setIsOpen(false);
        doRefreshToken();
      });
    }
  };
  // =========== end of Modal Seller Location State =========== //

  // =========== Handler for Countries and Provinces =========== //
  useEffect(() => {
    if (!countries.isFetch && !userData.isFetch) {
      if (countries.data.length && countries.status_code === 200) {
        const base = { value: '', label: 'Country*' };
        const data = countries.data.filter((c) => c.code3 === 'IDN');
        const country = data.map((country) => ({
          value: country.code3,
          label: country.name,
        }));
        const countryLocation = userData && userData.country_code;
        try {
          const currencyCode =
            CURRENCY_CODE[countryLocation === 'IDN' ? 'IDN' : 'ETC'];
          fetchCurrencyRate(currencyCode);
        } catch (error) {
          fetchCurrencyRate(CURRENCY_CODE['IDN']);
        }
        const getCountry = country.find((c) => c.value == countryLocation);
        if (!countrySelected) {
          if (getCountry) {
            setCountrySelected(getCountry);
          }
        }
        setCountryList([base, ...country]);
        if (getCountry) {
          fetchProvinces(getCountry.value);
        }
      }
    }
  }, [countries.isFetch, userData.isFetch]);
  useEffect(() => {
    if (provinces.data.length && provinces.status_code === 200) {
      const def = { value: 0, label: 'Provinsi*' };
      const { data } = provinces;
      const province = data.map((province, index) => ({
        value: province.id,
        label: province.name,
      }));
      const countryLocation = userData && userData.country_code;
      const sellerLocation =
        userData &&
        userData.user_setting &&
        userData.user_setting.seller_location_id;
      const getProvince = province.find((prov) => prov.value == sellerLocation);
      if (provinceSelected == null) {
        if (getProvince) {
          setProvinceSelected(getProvince);
        }
      }
      setProvinceList([def, ...province]);
      if (
        !sellerLocation ||
        (countrySelected?.value !== countryLocation &&
          getProvince?.value !== sellerLocation)
      ) {
        setIsOpen(true);
      }
    }
  }, [provinces.isFetch]);
  // =========== end of Handler for Countries and Provinces =========== //

  let payloadForGetData = {
    keyword: '',
    sort_by: '',
    category: '',
    status: '',
    page: 1,
    sneakers_condition: '',
    order_status: '',
  };

  const doGetData = () => {
    payloadForGetData = {
      keyword: dataUi.userDashboardKeyword,
      sort_by: dataUi.userDashboardSort,
      category: dataUi.userDashboardCategory,
      status,
      order_status: dataUi.userDashboardStatus,
      page: dataUi.userDashboardPage,
      sneakers_condition: '',
    };
    setGettingData(true);
    switch (activeTabs) {
      case 'Current':
        doListSelling({ params: payloadForGetData }).then(() => {
          setTimeout(() => setGettingData(false), 1500);
        });
        break;
      case 'In Progress':
        doListSellingProcess({ params: payloadForGetData }).then(() => {
          setTimeout(() => setGettingData(false), 1500);
        });
        break;
      case 'History':
        doSellsHistory({ params: payloadForGetData }).then(() => {
          setTimeout(() => setGettingData(false), 1500);
        });
        break;
      default:
        break;
    }
  };

  // Will be called every time ui reducer change to update payload for sort and filter list data
  useEffect(() => {
    doGetData();
  }, [
    dataUi.userDashboardCategory,
    dataUi.userDashboardKeyword,
    dataUi.userDashboardSort,
    dataUi.userDashboardStatus,
    dataUi.userDashboardPage,
  ]);

  useEffect(() => {
    if (!firstRender) doResetFilter();
    if (!firstRender && !isGettingData) doGetData();
  }, [status, activeTabs]);

  useEffect(() => {
    getCountries();
    setFirstRender(false);
    doSellsHistory({ params: { page: 1 } });
    if (
      !userData.isFetch &&
      userData.roles &&
      userData.roles.indexOf('user') !== -1 &&
      userData.roles.indexOf('seller') === -1
    ) {
      history.push('/seller-registration');
    }
    getSellingCommissionSetting()
      .then(res=> {
        setSellingCommissionData(res?.action?.payload?.data.data[0].value)
      })
  }, []);

  const _totalTransaction = ({ total_penjualan }: PenjualanInterface) => {
    if (!total_penjualan) return '-';

    return formatCurrency(total_penjualan, ratio, currency);
  };

  const onClickBack = () => {
    history.push({ pathname: `/user_dashboard` });
  };

  const onClickHolidayMode = () => {
    if (isSellerCreditMinus) {
      setIsOpenModalAlert(true);
    } else {
      toggleHolidayModeProfile(!userData.is_holiday).then((res) => {
        const payloadForHolidayMode = {
          active: res.value.data.is_holiday,
        };
        doSubmitHolidayMode(payloadForHolidayMode).then(() => {
          if (!res.value.data.is_holiday) {
            doGetData();
          }
        });
      });
    }
  };

  const onClickSellRequest = () => {
    if (isSuspended || isSellerCreditMinus) {
      return;
    }
    if (
      !dataAuth.userdata.seller_verification &&
      dataAuth.userdata.country_code === 'IDN' &&
      dataAuth.userdata.roles.includes('seller')
    ) {
      toggleSellerVerification();
      setIsOpenExistingModal(!isOpenExistingModal);
    }
    history.push({ pathname: '/sell-request' });
  };

  const onClickSendEmail = () => {
    doVerifyEmail().then(() => {
      toast.success(
        'Please check your email to continue the verification process.',
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        },
      );
    });
  };

  const onClickVerified = () => {
    fetchProfile().then(() => {
      refreshToken();
    });
  };

  /**
   * Function for handling tab changes
   * @param {string} targetTab target tab for changing to active.
   */
  function handleChangeTabs(targetTab: string) {
    setActiveTabs(targetTab);
  }

  /**
   * Function for rendering tabs data
   * @param {string} currentActiveTab current active tab from state.
   * @return {JSX.Element} react element
   */
  function renderTabContent(currentActiveTab: string) {
    switch (currentActiveTab) {
      case 'Current':
        return (
          <Current
            setIsOpenModalAlert={() => setIsOpenModalAlert(!isOpenModalAlert)}
            callbackAfterUpdate={doGetData}
            loading={isGettingData}
          />
        );
      case 'In Progress':
        return (
          <InProgress
            setIsOpenModalAlert={() => setIsOpenModalAlert(!isOpenModalAlert)}
            callbackAfterUpdate={doGetData}
            loading={isGettingData}
          />
        );
      case 'History':
        return (
          <History
            setIsOpenModalAlert={() => setIsOpenModalAlert(!isOpenModalAlert)}
            callbackAfterUpdate={doGetData}
            loading={isGettingData}
          />
        );
      default:
        return;
    }
  }

  /**
   * Rendering Unverified User UI
   * @return {JSX.Element}
   */
  function renderUnverified() {
    return (
      <div className={'empty-container'}>
        <KickImage src={UNVERIFIED_IMG} />
        <p className={'bottom-text'}>
          Attention, your email has not been verified. Please check your inbox /
          junk / spam for an email from no-reply@kickavenue.com and click the
          verification link in it.
        </p>
        <div className={'bottom-button'}>
          <div className={'button-send'} onClick={onClickSendEmail}>
            <p>Send email verification</p>
          </div>
          <div className={'button-verified'} onClick={onClickVerified}>
            <p>I'm verified!</p>
          </div>
        </div>
      </div>
    );
  }

  const sellerLocation =
    userData &&
    userData.user_setting &&
    userData.user_setting.seller_location_id;
  const sellerCountry = countries.data
    ? countries.data.find((c) => c.code3 === userData.country_code)
    : null;
  const sellerProvince =
    userData && userData.user_setting && userData.user_setting.seller_location;
  const sellerLocationArr = [sellerProvince?.name, sellerCountry?.name];
  const sellerLocationDisplaying = sellerLocationArr
    .filter((item) => item)
    .join(', ');

  const additionalId = activeTabs === 'In Progress' ? 'in-progress' : '';

  // isSuspended ? (
  //   <div className="suspended-seller-container">
  //     <PenjualanLoadingSkeleton onClick={onClickBack} />
  //     <SuspendedInfo />
  //   </div>
  // ) :
  return isUnverified ? (
    <div className="suspended-seller-container">{renderUnverified()}</div>
  ) : (
    <div className={'selling-container'} id={additionalId}>
      <div className={'title-container'}>
        <div className={'back-button'} onClick={onClickBack}>
          <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
            <div>
              <ImArrowLeft2 />
            </div>
          </IconContext.Provider>
        </div>
        <span className={'title'}>Selling Dashboard</span>
        <div
          className={'shipping-container'}
          onClick={toggleModalSellerLocation}
        >
          <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
            <div>
              <GrLocation />
            </div>
          </IconContext.Provider>
          <span className={'ship-to'}>
            Seller location
            <span className={'ship-to-location'}>
              {sellerLocation ? sellerLocationDisplaying : '-'}
            </span>
          </span>
          <IconContext.Provider value={{ color: '#242424', size: '10px' }}>
            <div>
              <GrFormDown />
            </div>
          </IconContext.Provider>
        </div>
      </div>

      <div className={'info-container'}>
        <div className={'info-box'}>
          <KickImage src={REVENUE_IMG} className={'icon'} />
          <p className={'title'}>Revenue</p>
          <p className={'value'}>{_totalTransaction(penjualan)}</p>
        </div>
        <div className={'info-box'}>
          <KickImage src={SALES_IMG} className={'icon'} />
          <p className={'title'}>Successful Sales</p>
          <p className={'value'}>
            {penjualan.success_transaction
              ? penjualan.success_transaction
              : '-'}
          </p>
        </div>
        <div className={'info-box point'} onClick={toggleModalSellerPoint}>
          <div className="seller-icon-container">
            <KickImage src={GREEN_STAR} className={'icon'} />
            {isSellerCreditMinus && (
              <KickImage src={RED_WARNING} className={'icon'} />
            )}
          </div>
          <p className={'title'}>
            Seller Point{' '}
            <KickImage
              src={INFO_BUTTON}
              className={'icon-button'}
              style={{ width: '14px', marginBottom: '5px' }}
            />
          </p>
          <p className={`value ${isSellerCreditMinus ? 'credit-minus' : ''}`}>
            {userData?.seller_points}
          </p>
        </div>
      </div>

      <div className={'seller-action-container'}>
        {!isSuspended && !isSellerCreditMinus ? (
          <div className={'holiday-mode'}>
            <p>Holiday Mode</p>
            <div
              onClick={onClickHolidayMode}
              className={`switch-container ${
                userData.is_holiday ? 'active' : ''
              }`}
            >
              <div
                className={`inner-switch ${
                  userData.is_holiday ? 'active' : ''
                }`}
              />
            </div>
          </div>
        ) : (
          <div
            onClick={() => {
              if (!isSuspended) {
                onClickHolidayMode();
              }
            }}
            className={`holiday-mode account-suspended`}
          >
            <p>Suspended</p>
            <div className={`switch-container active`}>
              <div className={`inner-switch active`} />
            </div>
          </div>
        )}

        <div className={Styles['sell-product']}>
          <Select
            className={Styles['select']}
            value={'Add/Edit Product(s)'}
            options={[
              {
                value: 'add',
                label: 'Add Product(s)',
              },
              {
                value: 'edit',
                label: 'Edit Product(s)',
              },
            ]}
            onSelect={(value) => {
              setSelectedActionBulkUpload(value);
              setIsOpenModalBulkUpload(true);
            }}
            placeholder={'Add/Edit Product(s)'}
            bordered={false}
          />

          {
            isDesktopView && 
            <div
              className={'sell-request'}
              style={{ backgroundColor: '#242424' }}
              onClick={onClickSellRequest}
            >
              <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
                <div>
                  <BsPlus style={{ color: 'white' }} />
                </div>
              </IconContext.Provider>
              <p style={{ color: 'white' }}>Sell a Product</p>
            </div>
          }
        </div>
      </div>

      <div className={'tab-container'}>
        {TABS.map((t) => {
          let classDiv = 'tabs';
          if (activeTabs === t) classDiv += ' active';
          return (
            <div
              key={t}
              className={classDiv}
              onClick={() => handleChangeTabs(t)}
            >
              <p>{t}</p>
              {activeTabs === t && <div className={'is-active-tabs'} />}
            </div>
          );
        })}

        {
          isMobileView && 
          <div
            className={Styles['sell-request']}
            style={{ backgroundColor: '#242424' }}
            onClick={onClickSellRequest}
          >
            <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
              <div>
                <BsPlus style={{ color: 'white' }} />
              </div>
            </IconContext.Provider>
            <p style={{ color: 'white' }}>Sell a Product</p>
          </div>
        }
      </div>

      <div className={'tab-content'}>{renderTabContent(activeTabs)}</div>
      {isOpenModalAlert ? (
        <ModalPenaltyAlert
          //@ts-ignore
          isOpen={isOpenModalAlert}
          //@ts-ignore
          openTopupModal={() => {
            setIsOpenModalAlert(false);
            setIsOpenModalTopup(true);
          }}
          //@ts-ignore
          onToggle={() => setIsOpenModalAlert(!isOpenModalAlert)}
          balance={balance}
          settleWithKickCredit={settleWithKickCredit}
          doRefreshToken={doRefreshToken}
          fetchProfile={fetchProfile}
          doGetData={doGetData}
          balance_with_fee={balance_with_fee}
          urlAfterSuccessTopup={urlAfterSuccessTopup}
          successAction={() => {
            setUrlAfterSuccessTopup('');
            setIsOpenModalAlert(!isOpenModalAlert);
          }}
        />
      ) : null}
      {isOpenModalTopup ? (
        <TopupForm
          //@ts-ignore
          isOpen={isOpenModalTopup}
          onToggle={() => setIsOpenModalTopup(!isOpenModalTopup)}
          onSubmit={(payload) => topup(payload)}
          dataTopUp={topUp}
          pageSelling={true}
          onSuccessTopUp={(url) => {
            setUrlAfterSuccessTopup(url);
            setIsOpenModalTopup(false);
            setIsOpenModalAlert(true);
          }}
        />
      ) : null}
      {isOpenSellerVerification && (
        <SellerVerification
          isExistingSeller={
            !dataAuth.userdata.seller_verification &&
            dataAuth.userdata.roles.includes('seller')
          }
          isOpen={isOpenSellerVerification}
          toggle={toggleSellerVerification}
          doRefreshToken={doRefreshToken}
          doVerifyOtp={doVerifyOtp}
          doSentCitCall={doSentCitCall}
          doSentSMS={doSentSMS}
          doSubmitPhone={doSubmitPhone}
          phoneNumber={phone}
          setPhone={setPhone}
          toggleExistingModal={toggleExistingModal}
          isOpenExistingModal={isOpenExistingModal}
          setIsOpenExistingModal={setIsOpenExistingModal}
        />
      )}

      <ModalSellerLocationV3
        isOpen={isOpen}
        onToggle={toggleModalSellerLocation}
        countryLocation={userData?.country_code}
        sellerLocation={userData?.user_setting?.seller_location_id}
        countryName={'countrySelected'}
        onChangeCountry={handleCountryChange}
        countryValue={countrySelected}
        countryOptions={countryList}
        name={'provinceSelected'}
        onChange={handleProvinceChange}
        value={provinceSelected}
        options={provinceList}
        onClick={onSubmitLocation}
        isSubmitted={locationSubmitted}
        errorProvince={
          errorLocation != null && errorLocation.status_code === 422
            ? errorLocation.errors.provinceSelected
            : undefined
        }
        errorCountry={
          errorLocation != null && errorLocation.status_code === 422
            ? errorLocation.errors.countrySelected
            : undefined
        }
      />

      {!isOpenModal ? null : (
        <ModalSellerPoint
          isOpen={isOpenModal}
          onToggle={toggleModalSellerPoint}
          sellerPoints={userData?.seller_points}
          sellingCommissionData={sellingCommissionData}
        />
      )}

      <ModalBulkUpload
        open={isOpenModalBulkUpload}
        visible={isOpenModalBulkUpload}
        action={selectedActionBulkUpload}
        fetchSellerProducts={doGetData}
        onCancel={() => {
          setIsOpenModalBulkUpload(false);
        }}
      />
    </div>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {
    penjualan: state.dataHistory.penjualan,
    ratio: state.dataAuth.userCurrency.ratio,
    currency: state.dataAuth.userCurrency.currency,
    userData: state.dataAuth.userdata,
    seller_points: state.dataAuth.userdata.seller_points,
    balance: state.dataAuth.userdata.balance,
    balance_with_fee: state.dataAuth.userdata.balance_with_fee,
    dataUi: state.dataUi,
    countries: state.dataPostalCode.countries,
    provinces: state.dataPostalCode.provinces,
    dataAuth: state.dataAuth,
    pengisian: state?.dataTopUp.pengisian,
    topUp: state?.dataTopUp.topUp,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    doListSelling: (query: queryGetData, ascDesc?: any) =>
      dispatch(listSelling(query, ascDesc)),
    doListSellingProcess: (query: queryGetData, ascDesc?: any) =>
      dispatch(processSelling(query, ascDesc)),
    doSellsHistory: (query: queryGetData, ascDesc?: any) =>
      dispatch(historySelling(query, ascDesc)),
    toggleHolidayModeProfile: (bool: boolean) => dispatch(doHolidayMode(bool)),
    doSubmitHolidayMode: (payload: payloadSubmitHolidayMode) =>
      dispatch(submitHolidayMode(payload)),
    doResetFilter: () => dispatch(doResetDashboardFilter()),
    fetchProvinces: (country: string) => dispatch(doFetchProvinces(country)),
    fetchCountries: () => dispatch(doFetchCountries()),
    updateProfile: (payload: UpdateProfileType) =>
      dispatch(doUpdateUserProfile(payload)),
    doUpdateUserCountry: (payload: UpdateUserCountryType) =>
      dispatch(updateUserCountry(payload)),
    fetchProfile: () => dispatch(doFetchProfile()),
    getCountries: () => dispatch(doFetchCountries()),
    fetchCurrencyRate: (payload) => dispatch(doFetchCurrencyRate(payload)),
    doRefreshToken: () => dispatch(doRefreshToken()),
    doVerifyEmail: () => dispatch(doSentLinkVerificationEmail()),
    refreshToken: () => dispatch(doRefreshToken()),
    doSentCitCall: (payload) => dispatch(doSentCitCall(payload)),
    doSentSMS: (payload) => dispatch(doSentSMS(payload)),
    doVerifyOtp: (payload) => dispatch(doVerifyOtp(payload)),
    doSubmitPhone: (payload) => dispatch(doSubmitPhone(payload)),
    topup: (payload) => dispatch(doTopUp(payload)),
    settleWithKickCredit: () => dispatch(settleWithKickCredit()),
    getSellingCommissionSetting: () => dispatch(getSellingCommissionSetting()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Penjualan);
